import {GrpcServicePool} from "../camera/camera_client";
import CameraConnectingImage from "../assets/camera/camera_loading.svg";
import NoCameraImage from "../assets/camera/no_camera.svg";

const grpcCameraPool = new GrpcServicePool(process.env.VUE_APP_GRPC_URL, process.env.VUE_APP_GRPC_SUBDOMAIN_COUNT||50);

export default {
  methods: {
    allocateGrpcService() {
      return grpcCameraPool.allocateGrpcService();
    },
    getConnectionImage() {
      return CameraConnectingImage;
    },
    getNoCameraImage() {
      return NoCameraImage;
    },
    convertFrameToUrlData(frame, isBase64) {
      if (isBase64) {
        return 'data:image/jpeg;base64,' + new window.TextDecoder("utf-8").decode(frame.getFrame_asU8());
      }
      const blob = new Blob( [ frame.getFrame_asU8() ], { type: "image/jpeg" } );
      const urlCreator = window.URL || window.webkitURL;

      return  urlCreator.createObjectURL(blob);
    }
  }
}
